<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="师傅id,外键{}" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入师傅id,外键{}" />
      </a-form-model-item>
      <a-form-model-item label="是否开启接单,0-否,1-是" prop="orderAccepting" >
        <a-input v-model="form.orderAccepting" placeholder="请输入是否开启接单,0-否,1-是" />
      </a-form-model-item>
      <a-form-model-item label="接单工种id列表,多个使用逗号隔开" prop="professionIds" >
        <a-input v-model="form.professionIds" placeholder="请输入接单工种id列表,多个使用逗号隔开" />
      </a-form-model-item>
      <a-form-model-item label="接受派单距离" prop="dispatchDistance" >
        <a-input v-model="form.dispatchDistance" placeholder="请输入接受派单距离" />
      </a-form-model-item>
      <a-form-model-item label="经度" prop="longitude" >
        <a-input v-model="form.longitude" placeholder="请输入经度" />
      </a-form-model-item>
      <a-form-model-item label="纬度" prop="latitude" >
        <a-input v-model="form.latitude" placeholder="请输入纬度" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {addSet, getSet, updateSet} from '@/api/order/set'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        orderAccepting: null,

        professionIds: null,

        dispatchDistance: null,

        longitude: null,

        latitude: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '师傅id,外键{}不能为空', trigger: 'blur' }
        ],
        orderAccepting: [
          { required: true, message: '是否开启接单,0-否,1-是不能为空', trigger: 'blur' }
        ],
        professionIds: [
          { required: true, message: '接单工种id列表,多个使用逗号隔开不能为空', trigger: 'blur' }
        ],
        dispatchDistance: [
          { required: true, message: '接受派单距离不能为空', trigger: 'blur' }
        ],
        longitude: [
          { required: true, message: '经度不能为空', trigger: 'blur' }
        ],
        latitude: [
          { required: true, message: '纬度不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        orderAccepting: null,
        professionIds: null,
        dispatchDistance: null,
        longitude: null,
        latitude: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSet({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSet(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSet(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
